/** An array of generic key field names for filtering them before conversion */
export const GENERIC_KEY_FIELD_NAMES = [
  'dataPond',
  'recordType',
  'tenant',
  'timeframe',
  'value',
  'metric.key',
  // these fields are added for the migration period but can be removed after grail updates
  'rollupType',
  'metricKey',
];
